import organization from './organization.json';

const frOrganization = {
    ...organization,
}

export default frOrganization;
